export default __webpack_public_path__ + "static/media/vodZ.d6bd650a.png";